/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/28
 * @Version : 1.0
 * @Content : 全局工具
 */

import axios from 'axios'
import cookies from 'vue-cookies'
import fetch from '@/utils/fetch'
import querystring from 'querystring'
import config from '@/config/authAbout/auth.config'
import token from '@/config/authAbout/token'
import login from '@/config/authAbout/loginUtil'
// import auth from '@/config/authAbout/auth.config'
import url from '@/config/url.config'

const plugin = {
  installed: false
}
plugin.install = (Vue) => {
  if (plugin.installed) return
  Object.defineProperties(Vue.prototype, {
    $bus: { value: new Vue() },
    $axios: { value: axios },
    $fetch: { value: fetch },
    $cookies: { value: cookies },
    $ajax: { value: axios },
    $config: { value: config },
    $token: { value: token },
    $login: { value: login },
    $querystring: { value: querystring },
    $url: { value: url }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin
